export default __webpack_public_path__ + "static/media/Armbands of Bestial Rage.fef1a55b.jpg";